import { MATERIAL_FILTER_OPTIONS } from '../../../../utils/status';
import { SearchFilterBar } from '@/components/base/SearchFilterBar';

interface MaterialFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  nhom: string;
  onNhomChange: (v: string) => void;
  nguon: string;
  onNguonChange: (v: string) => void;
  status: string;
  onStatusChange: (v: string) => void;
  seasonId: string;
  onSeasonChange: (v: string) => void;
  nhoms: string[];
  seasons: { id: string; name: string }[];
}

const STATUS_OPTIONS = MATERIAL_FILTER_OPTIONS;

export function MaterialFilters({
  search,
  onSearchChange,
  nhom,
  onNhomChange,
  nguon,
  onNguonChange,
  status,
  onStatusChange,
  seasonId,
  onSeasonChange,
  nhoms,
  seasons,
}: MaterialFiltersProps) {
  return (
    <div className="mb-4">
      <SearchFilterBar value={search} onChange={onSearchChange} placeholder="Tìm kiếm tên vật tư, mã vật tư..." selected={status} onSelect={onStatusChange} options={STATUS_OPTIONS.map((option) => ({ value: option.value, label: option.label }))}>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
        <select
          value={nhom}
          onChange={(e) => onNhomChange(e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500"
        >
          <option value="">Tất cả nhóm</option>
          {nhoms.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>

        <select
          value={nguon}
          onChange={(e) => onNguonChange(e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500"
        >
          <option value="">Tất cả nguồn</option>
          <option value="HTX cấp/ứng">HTX cấp/ứng</option>
          <option value="Nông hộ tự mua">Nông hộ tự mua</option>
        </select>

        <select
          value={seasonId}
          onChange={(e) => onSeasonChange(e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500"
        >
          <option value="">Tất cả mùa vụ</option>
          {seasons.map((s) => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>

      </div>
      </SearchFilterBar>
    </div>
  );
}
